module.exports = {
	"api_url": "https://api.mveva.com"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./resources/properties.json
 ** module id = 95
 ** module chunks = 0
 **/